import { z } from 'zod';
import { homePageSchema } from '@trinity/management-app-client';
import { TTSProvider } from '../types/tts-config.js';
import { AppFeatures } from '../types/store.interfaces.js';

export const AppStateFeaturesSchema = z.object({
  autoTagFiles: z.boolean(),
  deleteChatsOnSessionEnd: z.boolean(),
  hcpProfiles: z.boolean(),
  workspaces: z.boolean(),
  workspaceBrands: z.boolean(),
  chatVoiceInput: z.boolean(),
  chatReadAloud: z.boolean(),
  chatVoiceMode: z.boolean(),
  chatVoiceSource: z.string(),
  chatWelcomeScreen: z.boolean(),
  chatLiveAvatar: z.boolean(),
  chatLiveAvatarId: z.string(),
  chatLiveAvatarTtsConfig: z.object({ type: TTSProvider, voiceId: z.string() }),
  chatInteractionAvailableModes: z.string().array(),
  chatInteractionDefaultMode: z.string(),
  predictiveScheduling: z.boolean(),
  smartRouting: z.boolean(),
  hcpSchedulingAssistant: z.boolean(),
  speechServicesProvider: z.enum(['browser', 'azure-speech-services', 'aws-speech-services', 'custom']),
  uploadFiles: z.boolean(),
  copyChatMessages: z.boolean(),
  shareChats: z.boolean(),
  exportChatData: z.boolean(),
  engagementResponseLabels: z.boolean(),
  engagementFilter: z.boolean(),
  chatIconVisibility: z.boolean(),
  supportIcon: z.string(),
  documentIconVisibility: z.boolean(),
  followUps: z.boolean(),
  browserTabName: z.string().nullable(),
  chatAuraIframesEnabled: z.boolean(),
  // maxUserChatQueries: z.number().nullable(),
  chatFileUploads: z.boolean(),
  chatGuidelines: z.string().nullable(),
  disableChatInputWithLandingCards: z.boolean(),
  homeScreen: homePageSchema.nullable().prefault('chat'),
  homeButton: z.boolean(),
  homeButtonTopHeader: z.boolean(),
  chatContextSelector: z.boolean(),
  applicationTooltip: z.string().nullable(),

  hcpProfileElements: z.object({
    contactInformation: z.boolean(),
    interactionsSummary: z.boolean(),
    keyDiscussionQuestions: z.boolean(),
    keyInsights: z.boolean(),
    leaderTopics: z.boolean(),
    clinicalTrials: z.boolean(),
    publications: z.boolean(),
    conferencePresence: z.boolean(),
  }),
});

export type AppStateFeatures = AppFeatures;
export type GroupFeaturesContextValue = AppFeatures;
